var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { useRouter } from 'src/shared/hooks/useRouting';
import { authActions } from 'src/redux/auth/authActions';
import store from 'src/shared/store';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { URL_PATH } from 'src/shared/constants';
import { getI18n } from 'src/redux/core/coreSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { queriesParamsToObj } from 'src/shared/helpers/urlHelpers';
import { KeycloakEntity } from 'src/shared/KeycloakEntity';
import { Loader } from 'src/ui/components/Loader/Loader';
import { IDENTIFIER_HEADER, E_OPTION_MENU, buildIdentifierHeaderMenuItem, E_HEADER_MENU_ITEM, } from 'src/ui/components/header/constants';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { DropDownMenu } from 'src/ui/components/DropDown/DropDownMenu';
import { getIsCasesViewAllowed, getPermissions } from 'src/redux/auth/authSelectors';
import { E_PERMISSION_KEY } from 'src/services/auth/types/permissionsTypes';
import { casesActions } from 'src/redux/cases/casesActions';
import styles from './header.module.scss';
export var Header = function (props) {
    var _a;
    var _b, _c, _d, _e;
    var title = props.title;
    var replace = useRouter().replace;
    var dispatch = useDispatch();
    var permissions = useSelector(getPermissions);
    var i18n = useSelector(getI18n);
    var isCasesViewAllowed = useSelector(getIsCasesViewAllowed);
    var updateAutoPlay = function (value) { return dispatch(casesActions.updateAutoPlay(value)); };
    var isAuth = (_b = KeycloakEntity === null || KeycloakEntity === void 0 ? void 0 : KeycloakEntity.kc) === null || _b === void 0 ? void 0 : _b.authenticated;
    var _f = useState({ visible: false }), currentFocus = _f[0], setCurrentFocus = _f[1];
    useEffect(function () {
        var visible = currentFocus.visible, x = currentFocus.x, width = currentFocus.width;
        if (!visible && x && width) {
            var timeout_1 = setTimeout(function () {
                setCurrentFocus({ visible: false });
            }, 300);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [currentFocus]);
    if (!isAuth) {
        return null;
    }
    // Recursive function to get the header item node instead of the child node despite deep level
    var getHeaderItemNode = function (target) {
        var isHeaderItemElement = target.className && typeof target.className === 'string' ? target.className.includes(styles.headerNavItem) : false;
        if (isHeaderItemElement) {
            return target;
        }
        else {
            return getHeaderItemNode(target.parentNode);
        }
    };
    var handleHoverItem = function (e) {
        e.stopPropagation();
        e.preventDefault();
        var headerItemNode = getHeaderItemNode(e.target);
        var _a = headerItemNode.getBoundingClientRect(), x = _a.x, width = _a.width;
        var columnGap = 32;
        setCurrentFocus({ x: x - columnGap / 2, width: width + (columnGap / 2) * 2, visible: true });
    };
    var handleHoverLeave = function () {
        setCurrentFocus(function (prev) { return (__assign(__assign({}, prev), { visible: false })); });
    };
    var handleCasesRedirection = function () {
        updateAutoPlay(false);
        var queries = queriesParamsToObj(window.location.search);
        if (queries.filter) {
            replace(URL_PATH.CASES + window.location.search);
        }
        else {
            replace(URL_PATH.CASES);
        }
    };
    var handleAutoSearchRedirection = function () {
        updateAutoPlay(false);
        replace(URL_PATH.AUTO_SEARCH);
    };
    var handleOptionsClick = function (option) {
        if (option.id === E_OPTION_MENU.LOGOUT) {
            store.dispatch(authActions.logoutRequested());
        }
    };
    var focusSelectorElementClass = classNames((_a = {},
        _a[styles.headerFocus] = true,
        _a[styles.visible] = currentFocus.visible,
        _a));
    var isUserAllowed = permissions ? (_c = permissions[E_PERMISSION_KEY.USER_MANAGEMENT_VIEW]) === null || _c === void 0 ? void 0 : _c.allowed : false;
    var caseLabel = i18n ? getPropsByKeyPath(i18n.components, 'menu.cases') : '';
    var autoSearchLabel = i18n ? getPropsByKeyPath(i18n.components, 'menu.autoSearch') : '';
    var userLabel = i18n ? getPropsByKeyPath(i18n.components, 'menu.users') : '';
    var logoutLabel = i18n ? getPropsByKeyPath(i18n.components, 'appBar.menu.logout') : '';
    return (_jsxs("header", __assign({ "data-test": IDENTIFIER_HEADER, className: styles.header }, { children: [_jsx("h1", __assign({ className: styles.headerTitle, onClick: handleCasesRedirection }, { children: title })), _jsxs("nav", __assign({ className: styles.headerNav, onMouseLeave: handleHoverLeave }, { children: [_jsx("div", { className: focusSelectorElementClass, style: currentFocus.x && currentFocus.width
                            ? {
                                left: currentFocus.x,
                                minWidth: currentFocus.width,
                            }
                            : null }), isCasesViewAllowed ? (_jsxs("div", __assign({ "data-test": buildIdentifierHeaderMenuItem(E_HEADER_MENU_ITEM.CASES), className: styles.headerNavItem, onMouseMove: handleHoverItem, onClick: handleCasesRedirection }, { children: [_jsx(Icons, { icon: E_ICONS.FOLDER, className: styles.imageHeaderItemLeft, color: COLORS.WHITE }), caseLabel] }))) : (_jsxs("div", __assign({ "data-test": buildIdentifierHeaderMenuItem(E_HEADER_MENU_ITEM.CASES), className: styles.headerNavItem, onMouseMove: handleHoverItem, onClick: handleAutoSearchRedirection }, { children: [_jsx(Icons, { icon: E_ICONS.FULL_BOLT, className: styles.imageHeaderItemLeft, color: COLORS.WHITE }), autoSearchLabel] }))), isUserAllowed && (_jsxs("div", __assign({ "data-test": buildIdentifierHeaderMenuItem(E_HEADER_MENU_ITEM.USERS), className: styles.headerNavItem, onMouseMove: handleHoverItem, onClick: function () { return replace(URL_PATH.USERS); } }, { children: [_jsx(Icons, { icon: E_ICONS.GROUP, className: styles.imageHeaderItemLeft, color: COLORS.WHITE }), userLabel] }))), _jsx("div", __assign({ "data-test": buildIdentifierHeaderMenuItem(E_HEADER_MENU_ITEM.PROFILE), className: classNames(styles.headerNavItem, styles.headerNavItemOption), onMouseMove: handleHoverItem }, { children: ((_d = KeycloakEntity === null || KeycloakEntity === void 0 ? void 0 : KeycloakEntity.userInfo) === null || _d === void 0 ? void 0 : _d.preferred_username) ? (_jsx(DropDownMenu, { label: (_e = KeycloakEntity === null || KeycloakEntity === void 0 ? void 0 : KeycloakEntity.userInfo) === null || _e === void 0 ? void 0 : _e.preferred_username, options: [{ id: E_OPTION_MENU.LOGOUT, value: logoutLabel, icon: E_ICONS.LOGOUT }], onOptionClick: handleOptionsClick })) : (_jsx(Loader, { className: styles.headerNavItemLoader })) }))] }))] })));
};
